import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fire"
const FireIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.695 1.469C12.888 1.44 13.105 1.429 13.322 1.473 13.562 1.523 13.78 1.64 13.95 1.828 14.1 1.998 14.183 2.188 14.234 2.331 14.446 2.924 14.456 3.485 15.078 4.582 15.35 5.062 15.787 5.534 16.359 6.085 16.907 6.612 17.591 7.22 18.214 7.898 19.5 9.292 20.661 11.105 20.661 13.838 20.66 18.257 16.898 22.5 12.205 22.5 9.86 22.5 7.622 21.424 6.047 19.823 4.473 18.222 3.495 16.023 3.808 13.737 3.916 12.953 4.064 12.337 4.258 11.866 4.449 11.4 4.715 11.006 5.1 10.772 5.516 10.52 5.949 10.524 6.308 10.63 6.552 10.699 6.774 10.819 6.962 10.943 6.626 8.879 7.135 6.859 8.019 5.243 8.994 3.462 10.503 2.033 12.034 1.615 12.277 1.55 12.498 1.497 12.695 1.47M12.395 13.126C12.385 13.152 12.367 13.22 12.355 13.506 12.33 14.08 12.33 15.02 11.63 16.18 10.771 17.607 10.125 17.832 10.125 19.5 10.125 19.99 10.323 20.228 10.618 20.403 10.98 20.616 11.495 20.713 11.938 20.713 12.938 20.713 13.641 20.52 14.06 20.244 14.415 20.011 14.625 19.688 14.625 19.124 14.625 18.415 14.59 17.115 13.8 15.073 13.568 14.47 13.32 13.886 12.995 13.49 12.843 13.304 12.711 13.209 12.608 13.166 12.555 13.143 12.488 13.126 12.395 13.126M12.857 2.963C12.753 2.981 12.614 3.012 12.428 3.063 11.43 3.334 10.196 4.388 9.335 5.963 8.541 7.413 8.131 9.19 8.487 10.945L8.568 11.296 8.577 11.33 8.583 11.367C8.649 11.78 8.692 12.175 8.625 12.477 8.591 12.632 8.49 12.944 8.16 13.116 7.829 13.286 7.52 13.189 7.39 13.136 7.246 13.076 7.122 12.99 7.037 12.926 6.946 12.857 6.853 12.778 6.77 12.706 6.59 12.551 6.432 12.41 6.263 12.284 6.093 12.156 5.97 12.092 5.89 12.068L5.867 12.064C5.837 12.09 5.75 12.183 5.645 12.437 5.52 12.744 5.393 13.222 5.295 13.94 5.058 15.662 5.787 17.419 7.116 18.77 7.693 19.357 8.37 19.853 9.106 20.228 9.038 20.013 9 19.77 9 19.5 9 17.546 9.875 16.806 10.538 15.803L10.668 15.6C11.712 13.863 10.732 12.924 11.824 12.132L11.938 12.056C13.64 11.653 14.4 13.503 14.85 14.666 15.703 16.87 15.75 18.316 15.75 19.125Q15.748 19.61 15.61 20.005C17.716 18.71 19.161 16.316 19.161 13.84 19.16 11.607 18.24 10.139 17.11 8.915 16.528 8.282 15.923 7.746 15.32 7.165 14.739 6.607 14.16 6.007 13.773 5.322 13.16 4.242 12.959 3.342 12.857 2.963"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FireIcon
